import stores from "../stores/index.js";
import {projectUuid, syncHandler} from "../model/index.js";

export interface Sync {
	setHandler:          (handler: syncHandler, fn: (data: any) => void) => void;
	setReconnectHandler: (fn: () => void) => void;
	handle:              (handler: syncHandler, data: any) => void;
	destroy:             () => void;
}

export type outSyncHandler = (projectUuid: projectUuid | null, type: syncHandler, data: object) => void;

export function setupSyncHandlers(sync: Sync) {
	console.debug("PN Data Sync: setting up handlers");
	Object.values(stores).forEach(s => s._setupSyncHandlers(sync));
}

export function setupOutSyncHandlers(handler: outSyncHandler) {
	console.debug("PN Data OutSync: setting up reactions");
	Object.values(stores).forEach(s => s._setupOutSyncHandlers(handler));
}
